var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradientIllustration = function SvgGradientIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 910,
    height: 681,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gradientIllustration_svg__a)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradientIllustration_svg__b)",
    fillOpacity: 0.77,
    d: "M896.162 333.6c-34.773 187.968 396.048 399.924 295.048 381.24s-701.759-39.931-666.986-227.899c34.773-187.967-401.504-339.892-300.507-321.208s707.218-20.1 672.445 167.867"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientIllustration_svg__b",
    x1: 864.423,
    x2: 521.994,
    y1: 325.433,
    y2: 407.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91CEFB",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A893FE",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gradientIllustration_svg__a",
    width: 1413.68,
    height: 967.417,
    x: 0.706,
    y: -43.624,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_420_542",
    stdDeviation: 103.9
  })))));
};
export default SvgGradientIllustration;